import { createAction } from "@reduxjs/toolkit";
export var UsersActionType;
(function (UsersActionType) {
    UsersActionType["GET_ALL_USERS"] = "USERS/GET_ALL";
    UsersActionType["GET_ALL_USERS_SUCCESSFUL"] = "USERS/GET_ALL_SUCCESSFUL";
    UsersActionType["GET_ALL_USERS_FAILURE"] = "USERS/GET_ALL_FAILURE";
    UsersActionType["GET_ALLOWED_USERS"] = "USERS/GET_ALLOWED";
    UsersActionType["GET_ALLOWED_USERS_SUCCESSFUL"] = "USERS/GET_ALLOWED_SUCCESSFUL";
    UsersActionType["GET_ALLOWED_USERS_FAILURE"] = "USERS/GET_ALLOWED_FAILURE";
    UsersActionType["GET_NOT_ALLOWED_USERS"] = "USERS/GET_NOT_ALLOWED";
    UsersActionType["GET_NOT_ALLOWED_USERS_SUCCESSFUL"] = "USERS/GET_NOT_ALLOWED_SUCCESSFUL";
    UsersActionType["GET_NOT_ALLOWED_USERS_FAILURE"] = "USERS/GET_NOT_ALLOWED_FAILURE";
    UsersActionType["RESET_NOT_ALLOWED_USERS"] = "USERS/RESET_NOT_ALLOWED";
    UsersActionType["SET_REMOVE_USERS_ACCESS_DIALOG_OPEN"] = "USERS/SET_REMOVE_ACCESS_DIALOG_OPEN";
    UsersActionType["SET_GRANT_USERS_ACCESS_DIALOG_OPEN"] = "USERS/SET_GRANT_ACCESS_DIALOG_OPEN";
    UsersActionType["EDIT_USERS_ACCESS"] = "USERS/EDIT_ACCESS";
    UsersActionType["EDIT_USERS_ACCESS_SUCCESSFUL"] = "USERS/EDIT_ACCESS_SUCCESSFUL";
    UsersActionType["EDIT_USERS_ACCESS_FAILURE"] = "USERS/EDIT_ACCESS_FAILURE";
    UsersActionType["REMOVE_USERS_ACCESS"] = "USERS/REMOVE_ACCESS";
    UsersActionType["REMOVE_USERS_ACCESS_SUCCESSFUL"] = "USERS/REMOVE_ACCESS_SUCCESSFUL";
    UsersActionType["REMOVE_USERS_ACCESS_FAILURE"] = "USERS/REMOVE_ACCESS_FAILURE";
})(UsersActionType || (UsersActionType = {}));
export const getAllowedUsers = createAction(UsersActionType.GET_ALLOWED_USERS);
export const getAllowedUsersSuccessful = createAction(UsersActionType.GET_ALLOWED_USERS_SUCCESSFUL);
export const getAllowedUsersFailure = createAction(UsersActionType.GET_ALLOWED_USERS_FAILURE);
export const getAllUsers = createAction(UsersActionType.GET_ALL_USERS);
export const getAllUsersSuccessful = createAction(UsersActionType.GET_ALL_USERS_SUCCESSFUL);
export const getAllUsersFailure = createAction(UsersActionType.GET_ALL_USERS_FAILURE);
export const getNotAllowedUsers = createAction(UsersActionType.GET_NOT_ALLOWED_USERS);
export const getNotAllowedUsersSuccessful = createAction(UsersActionType.GET_NOT_ALLOWED_USERS_SUCCESSFUL);
export const getNotAllowedUsersFailure = createAction(UsersActionType.GET_NOT_ALLOWED_USERS_FAILURE);
export const resetNotAllowedUsers = createAction(UsersActionType.RESET_NOT_ALLOWED_USERS);
export const setRemoveUsersAccessDialogOpen = createAction(UsersActionType.SET_REMOVE_USERS_ACCESS_DIALOG_OPEN);
export const setGrantUsersAccessDialogOpen = createAction(UsersActionType.SET_GRANT_USERS_ACCESS_DIALOG_OPEN);
export const editUsersAccess = createAction(UsersActionType.EDIT_USERS_ACCESS);
export const editUsersAccessSuccessful = createAction(UsersActionType.EDIT_USERS_ACCESS_SUCCESSFUL);
export const editUsersAccessFailure = createAction(UsersActionType.EDIT_USERS_ACCESS_FAILURE);
export const removeUsersAccess = createAction(UsersActionType.REMOVE_USERS_ACCESS);
export const removeUsersAccessSuccessful = createAction(UsersActionType.REMOVE_USERS_ACCESS_SUCCESSFUL);
export const removeUsersAccessFailure = createAction(UsersActionType.REMOVE_USERS_ACCESS_FAILURE);
